import React, { FC, useCallback, useEffect } from "react";
import { generate } from "../../../../utils/sid";
import { Field } from "../FieldHandler";
import { useCurrentInventoryId } from "../../../../hooks/url";
import { useCurrentProject } from "../../../../hooks/database/useCurrentProject";

const SerialNumberField: FC<{
  field: Field & { type: "löpnummer" };
  onChange: (key: string, value: string | undefined) => void;
}> = (props) => {
  const { inventoryId: currentInventory } = useCurrentInventoryId();
  const { data: project } = useCurrentProject();

  const createDocumentHash = useCallback(() => {
    const time = new Date().toISOString().split(".")[0].replace(/:/g, "").replace(/-/g, "");
    const rnd = generate(4);

    return [project!.name, project!.inventories![currentInventory!].name, time, rnd].join("-");
  }, [currentInventory, project]);

  useEffect(() => {
    if (!props.field.value && project) {
      props.onChange(props.field.key, createDocumentHash());
    }
  }, [createDocumentHash, project, props]);

  return (
    <span>
      <input className="lopnummer" type="text" placeholder="<Auto-generated field>" value={props.field.value || ""} />
    </span>
  );
};

export default SerialNumberField;
